module.exports = __webpack_public_path__ + "assets/7e88cc8084bbf5a39299a194dbc75ff5.site-logo.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/site-logo.svg
 ** module id = 150
 ** module chunks = 1
 **/